import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { ViewMode } from '@/components/BlogPage/PostsList/ListViewModeToggle';
import { gsap } from '@/lib/gsap';
export const useViewMode = containerRef => {
  const $ = _c(8);
  const [viewMode, setViewMode] = useState("table");
  let t0;
  if ($[0] !== containerRef || $[1] !== viewMode) {
    t0 = mode => {
      if (mode === viewMode) {
        return;
      }
      if (!containerRef.current) {
        return;
      }
      localStorage.setItem("viewMode", mode);
      gsap.to(containerRef.current, {
        opacity: 0,
        duration: 0.2,
        onComplete: () => {
          setViewMode(mode);
        }
      });
    };
    $[0] = containerRef;
    $[1] = viewMode;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleViewModeChange = t0;
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const storedViewMode = localStorage.getItem("viewMode") as ViewMode;
      if (storedViewMode && (storedViewMode === "table" || storedViewMode === "grid")) {
        setViewMode(storedViewMode);
      }
    };
    t2 = [];
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== handleViewModeChange || $[6] !== viewMode) {
    t3 = {
      viewMode,
      handleViewModeChange
    };
    $[5] = handleViewModeChange;
    $[6] = viewMode;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};